import { Project, Identifiable, Status } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    statuses: Identifiable<Status>[];
  };
};

function getTaskStatuses(httpClient: HttpClient) {
  return (project: Identifiable<Project>): Promise<Identifiable<Status>[]> =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${project.uuid}/possibleStatuses`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded: { statuses: customStatuses } }) =>
        httpClient
          .sendHttpRequest<Response>({
            endpoint: `/statuses/search/findGeneralStatuses`,
            method: HttpMethods.GET,
          })
          .then(({ _embedded: { statuses: globalStatuses } }) => [
            ...globalStatuses.map((s) => ({ ...s, basic: true })),
            ...customStatuses,
          ]),
      );
}

export { getTaskStatuses };
